import styled from '@emotion/styled'

export const Header = styled.div`
  margin-bottom: 2rem;
  padding: 0 1rem;

  &:hover {
    opacity: 70%;
    cursor: pointer;
  }
`
